module.exports = __webpack_public_path__ + "static/media/johnJones05.0806d29d.png";